export const CreateCourseSteps = [
  { label: 'مشخصات دوره', value: 1 },
  { label: 'مشخصات تکمیلی دوره', value: 2 },
  { label: 'گام های دوره', value: 3 },
];

export const CREATE_STEP_STEPS = [
  { label: 'مشخصات دوره', value: 1 },
  { label: 'امتیاز', value: 2 },
  { label: 'آزمون', value: 3 },
];
